<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
    name: "form-add-materi",
    props: ['idPembelajaran'],
    data() {
        return {
            materiName: "",
            materiLink: "",
            materiDesc: "",
            materi_data: [],
            materi_ref: [],
            status_ref: ['Tersedia', 'Tidak Tersedia'],
            isAddMaster: false
        };
    },
    mounted() { },
    methods: {
        addRowMateri() {
            let self = this;
            self.materi_data.push({
                materi_data: ""
            });
        },
        deleteRow(index, row_data) {
            let self = this;
            var idx = self.materi_data.indexOf(row_data);
            if (idx > -1) {
                self.materi_data.splice(idx, 1);
            }
        },
        onSearchMateri(search, loading) {
            if (search.length) {
                loading(true);
                this.searchMateri(loading, search, this);
            }
        },
        searchMateri: function (loading, search) {
            let self = this;
            var config = {
                method: "get",
                url:
                    process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/search-materi",
                params: {
                    search: search,
                },
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token,
                },
            };
            axios(config).then((response) => {
                if (response.data.meta.code == 200) {
                    self.materi_ref = response.data.data.referensi;
                    loading(false);
                } else {
                    self.peserta_ref = [
                        {
                            a_id: 0,
                            materi: "-",
                        },
                    ];
                    loading(false);
                }
            });
        },
        validationForm() {
            if (this.materiName == '' || this.materiLink == '' || this.materiDesc == '') {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Terdapat inputan kosong!",
                });
                return
            }
            this.storeDataMaster()
        },
        storeData() {
            let self = this;
            Swal.fire({
                title: '<i class="fas fa-spinner fa-spin"></i>',
                text: "Loading...",
                showConfirmButton: false,
                allowOutsideClick: false,
            });

            const conf = {
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/pra-pelaksanaan/materi",
                method: 'post',
                data: {
                    materis: JSON.stringify(this.materi_data),
                    idPembelajaran: this.idPembelajaran
                },
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token
                }
            }

            axios(conf).then(res => {
                console.log(res)
                Swal.fire({
                    icon: "success",
                    title: "Berhasil",
                    text: "Data berhasil di simpan.",
                    timer: 2000,
                    timerProgressBar: true,
                    showCancelButton: false,
                    showConfirmButton: false,
                }).then((result) => {
                    /* Read more about handling dismissals below */
                    if (result.dismiss === Swal.DismissReason.timer) {
                        Swal.close();

                        var dataDuplicate = []
                        if (res.data.data[0]) {
                            dataDuplicate = res.data.data[0]
                        }
                        self.$emit("refresh-table", dataDuplicate);
                    }
                });
            })
        },
        storeDataMaster() {
            let self = this;
            Swal.fire({
                title: '<i class="fas fa-spinner fa-spin"></i>',
                text: "Loading...",
                showConfirmButton: false,
            });

            var config_store_data = {
                method: "post",
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/materi-pembelajaran",
                data: {
                    mPembelajaran_nama: self.materiName,
                    mPembelajaran_deskripsi: self.materiDesc,
                    mPembelajaran_link: self.materiLink
                },
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token,
                },
            };

            axios(config_store_data)
                .then(function (response) {
                    console.log(response);
                    Swal.fire({
                        icon: "success",
                        title: "Berhasil",
                        text: "Data berhasil di simpan.",
                        timer: 2000,
                        timerProgressBar: true,
                        showCancelButton: false,
                        showConfirmButton: false,
                    }).then((result) => {
                        /* Read more about handling dismissals below */
                        if (result.dismiss === Swal.DismissReason.timer) {
                            self.resetInputMateriMaster()
                            self.isAddMaster = false
                            Swal.close();
                        }
                    });
                })
                .catch(function (error) {
                    Swal.close();
                    self.axiosCatchError = error.response.data.data;
                });
        },
        resetInputMateriMaster() {
            this.materiName = ""
            this.materiLink = ""
            this.materiDesc = ""
        }
    },
};
</script>
<template>
    <b-form class="p-2" @submit.prevent="validationForm">
        <div class="row">
            <div class="col-12">

            </div>
        </div>
        <div class="row mb-2">
            <div class="col-12">
                <div class="">
                    <button v-if="isAddMaster == false" type="button" @click="isAddMaster = true"
                        class="btn btn-sm btn-success"><i class="fa fa-plus"></i> Tambah Materi Master</button>
                    <button v-else type="button" @click="isAddMaster = false" class="btn btn-sm btn-warning"><i
                            class="fa fa-times"></i> Tutup Materi Master</button>
                </div>
            </div>
        </div>
        <div v-if="isAddMaster == true" class="row">
            <div class="col-lg-12 mt-1">
                <b-form-group label="Nama" label-for="mPembelajaran_nama">
                    <b-form-input id="mPembelajaran_nama" placeholder="Masukkan Nama..." type="text"
                        v-model="materiName"></b-form-input>
                </b-form-group>
            </div>
            <div class="col-lg-12 mt-1">
                <b-form-group label="Link" label-for="mPembelajaran_link">
                    <textarea class="form-control" id="mPembelajaran_link" cols="30" rows="5" placeholder="Masukkan Link"
                        v-model="materiLink"></textarea>
                </b-form-group>
            </div>
            <div class="col-lg-12 mt-1">
                <b-form-group label="Deskripsi" label-for="mPembelajaran_deskripsi">
                    <textarea class="form-control" id="mPembelajaran_deskripsi" cols="30" rows="10"
                        placeholder="Masukkan Deskripsi" v-model="materiDesc"></textarea>
                </b-form-group>
            </div>
            <!-- end col -->
            <div class="col-lg-6">&nbsp;</div>
            <div class="col-lg-6">
                <div class="text-end">
                    <b-button type="reset" variant="danger">
                        <i class="fa fa-redo-alt"></i> Reset
                    </b-button>
                    &nbsp;
                    <b-button type="submit" variant="primary">
                        <i class="fa fa-save"></i> Simpan
                    </b-button>
                </div>
            </div>
            <!-- end col -->
        </div>
    </b-form>
    <b-form class="p-2" @submit.prevent="storeData">
        <div v-if="isAddMaster == false" class="">
            <table class="table mb-0 mt-0 table-bordered table-condensed table-hover">
                <thead class="bg-dark text-center text-white">
                    <tr>
                        <th style="width: 50px">No</th>
                        <th style="width: auto">Materi</th>
                        <th style="width: 50px" class="text-center">
                            <b-button type="button" class="btn btn-success btn-sm" v-on:click="addRowMateri">
                                <i class="fa fa-plus"></i>
                            </b-button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row_data, key_data) in materi_data" :key="key_data">
                        <td class="text-center">{{ key_data + 1 }}.</td>
                        <td>
                            <v-select label="materi" v-model="row_data.materi_data" :options="materi_ref"
                                @search="onSearchMateri" placeholder="Cari dan Pilih Materi...">
                            </v-select>
                        </td>
                        <td>
                            <div class="text-center">
                                <div class="btn btn-sm btn-danger" v-on:click="deleteRow(key_data, row_data)">
                                    <i class="fa fa-minus"></i>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <hr>
            <div class="row">
                <div class="col-lg-6">&nbsp;</div>
                <div class="col-lg-6 mb-4">
                    <div class="text-end">
                        <b-button type="reset" variant="danger">
                            <i class="fa fa-redo-alt"></i> Reset
                        </b-button>
                        &nbsp;
                        <b-button type="submit" variant="primary">
                            <i class="fa fa-save"></i> Simpan
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
    </b-form>
</template>
